/**
 * Form validation utilities for authentication
 */

export const authValidation = {
  /**
   * Validate email format
   */
  isValidEmail: (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },

  /**
   * Validate password strength
   */
  validatePassword: (password) => {
    const errors = [];

    if (!password) {
      errors.push("Password is required");
    } else {
      if (password.length < 8) {
        errors.push("Password must be at least 8 characters long");
      }
      if (!/(?=.*[a-z])/.test(password)) {
        errors.push("Password must contain at least one lowercase letter");
      }
      if (!/(?=.*[A-Z])/.test(password)) {
        errors.push("Password must contain at least one uppercase letter");
      }
      if (!/(?=.*\d)/.test(password)) {
        errors.push("Password must contain at least one number");
      }
      if (!/(?=.*[@$!%*?&])/.test(password)) {
        errors.push(
          "Password must contain at least one special character (@$!%*?&)",
        );
      }
    }

    return {
      isValid: errors.length === 0,
      errors,
      strength:
        errors.length === 0 ? "strong" : errors.length <= 2 ? "medium" : "weak",
    };
  },

  /**
   * Validate username format
   */
  validateUsername: (username) => {
    const errors = [];

    if (!username) {
      errors.push("Username is required");
    } else {
      if (username.length < 3 || username.length > 100) {
        errors.push("Username must be between 3 and 100 characters");
      }
      if (!/^[a-zA-Z0-9_-]+$/.test(username)) {
        errors.push(
          "Username can only contain letters, numbers, underscores, and hyphens",
        );
      }
    }

    return {
      isValid: errors.length === 0,
      errors,
    };
  },
};
